import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import FooterBar from './FooterBar'
import LinkTreeFormHandler from './_form/LinkTreeFormHandler'
import LinkTreeItems from './LinkTreeItems'
import LinkTreeItemsLoader from './_load/LinkTreeItemsLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const EditLinkTreeItemsModal = props => {
  const { t } = useTranslation('editLinkTreeItems')
  const item = useModalData()

  return (
    <ControlledModal width="62rem" disableClickOutside {...props}>
      <Title size="h4" align="center" noMargin>
        {t('customizeLinks')}
      </Title>
      <SmallText align="center">{item ? item.name : ''}</SmallText>
      <Separator weight={4} />
      <LinkTreeItemsLoader>
        <LinkTreeFormHandler>
          <LinkTreeItems />
          <Separator weight={4} />
          <FooterBar />
        </LinkTreeFormHandler>
      </LinkTreeItemsLoader>
    </ControlledModal>
  )
}

export default EditLinkTreeItemsModal
